import React from 'react';
import PropTypes from 'prop-types';
import { LEFT_NAVIGATION } from 'common/utils/EventTracker/utils/eventConstants';
import HomeLink from './HomeLink';
import LeftNavLink from './LeftNavLink';
import { getInvoicesPath } from '../utils';
import '../stylesheets/leftNav.scss';

// eslint-disable-next-line consistent-return
const isActivePath = (currentPath, targetPath) => {
  // eslint-disable-next-line default-case
  switch (targetPath) {
    case '/dashboard':
      return currentPath.startsWith(targetPath) && !currentPath.includes('/clients/all');
    case '/dashboard/clients/all':
    case '/exports':
    case '/insights':
    case '/network':
    case '/browse-resources':
    case '/invoices':
    case '/enrollments':
    case '/authorizations':
      return currentPath.startsWith(targetPath);
    case '/tasksv3':
      return currentPath === '/tasksv3' || currentPath.startsWith('/tasksv3/');
  }
};

const LeftNav = ({
  isNetworkLead,
  isPayer,
  linkToPath,
  onLeftNavLinkClick,
  showAuthorizations,
  showInsights,
  showTasks,
  showExports,
  showNetworkDirectory,
  showDashboard,
  showContacts,
  showInvoices,
  showEnrollments,
  showPayerInvoices,
  isOrgActive,
  currentPath,
}) => (
  <div className="left-nav">
    <HomeLink onClick={() => linkToPath(isOrgActive ? '/' : '/organization/settings', LEFT_NAVIGATION.homeLink)} />
    <ul className="left-nav-align list-unstyled">
      {
        isOrgActive && (
          <>
            {
              showDashboard && !isNetworkLead && (
                <LeftNavLink
                  id="nav-workflow-dashboard"
                  eventType={LEFT_NAVIGATION.dashboardLink}
                  onLeftNavLinkClick={onLeftNavLinkClick}
                  path="/dashboard"
                  active={isActivePath(currentPath, '/dashboard')}
                >
                  Dashboard
                </LeftNavLink>
              )
            }
            {
              showContacts && !isNetworkLead && (
                <LeftNavLink
                  id="nav-clients"
                  eventType={LEFT_NAVIGATION.clientLink}
                  onLeftNavLinkClick={onLeftNavLinkClick}
                  path="/dashboard/clients/all"
                  active={isActivePath(currentPath, '/dashboard/clients/all')}
                >
                  Clients
                </LeftNavLink>
              )
            }
            {
              showExports && !isNetworkLead && (
                <LeftNavLink
                  id="nav-exports"
                  eventType={LEFT_NAVIGATION.exportsLink}
                  onLeftNavLinkClick={onLeftNavLinkClick}
                  path="/exports"
                  active={isActivePath(currentPath, '/exports')}
                >
                  Exports
                </LeftNavLink>
              )
            }
            {
              showInsights && (
                <LeftNavLink
                  id="nav-insights"
                  eventType={LEFT_NAVIGATION.insightsLink}
                  onLeftNavLinkClick={onLeftNavLinkClick}
                  path="/insights"
                  active={isActivePath(currentPath, '/insights')}
                >
                  Insights
                </LeftNavLink>
              )
            }
          </>
        )
      }
      {
        showNetworkDirectory && (
          <LeftNavLink
            id="nav-my-networks"
            eventType={LEFT_NAVIGATION.networkLink}
            onLeftNavLinkClick={onLeftNavLinkClick}
            path="/browse-resources"
            active={isActivePath(currentPath, '/browse-resources')}
          >
            Browse Resources
          </LeftNavLink>
        )
      }
      {
        showTasks && (
          <LeftNavLink
            id="nav-tasks-v3"
            eventType={LEFT_NAVIGATION.tasksListLink}
            onLeftNavLinkClick={onLeftNavLinkClick}
            path="/tasksv3/all"
            active={isActivePath(currentPath, '/tasksv3')}
          >
            Tasks
          </LeftNavLink>
        )
      }

      {
        isOrgActive && (
          <>
            {
              showInvoices && (
                <LeftNavLink
                  id="nav-invoices"
                  eventType={LEFT_NAVIGATION.invoicesLink}
                  onLeftNavLinkClick={onLeftNavLinkClick}
                  path={getInvoicesPath({ isNetworkLead, showPayerInvoices })}
                  active={isActivePath(currentPath, '/invoices')}
                >
                  Invoices
                </LeftNavLink>
              )
            }
            {
              showEnrollments && isPayer && (
                <LeftNavLink
                  id="nav-enrollments"
                  eventType={LEFT_NAVIGATION.enrollmentsLink}
                  onLeftNavLinkClick={onLeftNavLinkClick}
                  path="/enrollments"
                  active={isActivePath(currentPath, '/enrollments')}
                >
                  Enrollments
                </LeftNavLink>
              )
            }
            {
              showAuthorizations && isPayer && (
                <LeftNavLink
                  id="nav-authorizations"
                  eventType={LEFT_NAVIGATION.authorizationsLink}
                  onLeftNavLinkClick={onLeftNavLinkClick}
                  path="/authorizations"
                  active={isActivePath(currentPath, '/authorizations')}
                >
                  Authorizations
                </LeftNavLink>
              )
            }
          </>
        )
      }

    </ul>
  </div>
);

LeftNav.propTypes = {
  isNetworkLead: PropTypes.bool,
  isPayer: PropTypes.bool,
  linkToPath: PropTypes.func.isRequired,
  onLeftNavLinkClick: PropTypes.func.isRequired,
  showInsights: PropTypes.bool.isRequired,
  showTasks: PropTypes.bool.isRequired,
  showInvoices: PropTypes.bool.isRequired,
  showEnrollments: PropTypes.bool.isRequired,
  showAuthorizations: PropTypes.bool.isRequired,
  showExports: PropTypes.bool.isRequired,
  showNetworkDirectory: PropTypes.bool.isRequired,
  showDashboard: PropTypes.bool.isRequired,
  showContacts: PropTypes.bool.isRequired,
  showPayerInvoices: PropTypes.bool.isRequired,
  isOrgActive: PropTypes.bool.isRequired,
  currentPath: PropTypes.string.isRequired,
};

LeftNav.defaultProps = {
  isNetworkLead: false,
  isPayer: false,
};

export default LeftNav;
